import MigrationConfirm from './MigrationConfirm';

export * from './MigrationConfirm';

export default MigrationConfirm;



// WEBPACK FOOTER //
// ./foody/src/components/migration-confirm/index.js